<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Point Plan
            </template>
            <template v-slot:pageDetail>
                List
            </template>
        </o-bread-crumb>

        <FeatureGate featureKey="point_control">
        <div v-if="validation">
            <div class="alert alert-danger mt-1" role="alert">
                {{ validation }}
            </div>
        </div>
        <div v-if="thisComponentShow" class="card text-center">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2s">
                    <li class="nav-item">
                        <div class="d-flex d-inline-block">
                            <a class="nav-link text-dark fs-4" href="#">
                                {{ showCorporatePointPlan ? 'Corporate Point Plan' : 'Merchant Point Plan' }}
                            </a>
                        </div>
                    </li>
                    <li class="nav-item d-flex">
                        <div class="btn btn-primary btn-sm me-2" v-if="!pointplans.length && (showCorporatePointPlan || selectedBusinessProfile.merchant_id != null) && write">
                            <router-link :to="{ name: 'PointPlanForm' }" class="nav-link text-white">Set Point Plan
                            </router-link>
                        </div>
                         <div class="btn btn-primary btn-sm">
                            <button class="reload nav-link text-white" @click.prevent="load_state()" style="border:none; background:transparent;">&#x21bb;</button>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="card-body">
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
            <div class="spinner" v-if='page.isLoading'></div>
            <div class="" v-if="page.output">
                <!-- Merchant selector only shown in DECENTRALIZE mode -->
                <div class="d-flex d-inline-block" v-if="!showCorporatePointPlan && selectedBusinessProfile.merchant_id == null">
                    <div class="form-group">
                        <label for="">Merchant id</label>
                        <o-select v-model="selectMerchant" :options="merchants" autocomplete="'off'"></o-select>
                    </div>                    
                </div>
                <!-- Info for Corporate Point Plan -->
                <div class="alert alert-info" v-if="showCorporatePointPlan">
                    <i class="fas fa-info-circle me-2"></i>
                    <strong>Centralized Mode:</strong> Point Plans are managed at Corporate level and will be applied to all merchants.
                </div>

                <o-table style="text-align:left;" class="table-hover list-table">
                    <thead>
                        <tr>
                            <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                {{ field }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-for="(item, index) in pointplans" :key="index">
                            <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div>{{ item.id.slice(0, 9) + '...' }}</div>
                                    <button class="btn btn-sm btn-secondary ms-2" @click="copyToClipboard(item.id)">Copy</button>
                                </div>
                            </td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.point }}</td>
                            <td>{{ formatPrice(item.price) }}</td>
                            <td class="ml-3">
                                <div class="d-flex">
                                    <div class="me-1">
                                        <button class="btn btn-sm btn-info rounded-pill text-white" v-if="write">
                                            <router-link class="text-white" :to="{ name: 'PointPlanEdit', params: { id: item.id } }">Edit
                                            </router-link>
                                        </button>
                                    </div>
                                    <!-- <div>
                                        <button class="btn btn-sm btn-danger rounded-pill text-white">
                                            <router-link class="text-white" :to="{ name: 'PointPlan' }" @click.prevent="destroy(item.id, index)">Delete
                                            </router-link>
                                        </button>
                                    </div> -->
                                </div>
                            </td>
                    </tr>
                    </tbody>
                </o-table>
            </div>
            </div>
            <div class="container mt-5">
                <o-pagination :page="meta.page"  :total="meta.total" @callback="navPage"/>
            </div>
        </div>
        </FeatureGate>
    </div>
    <br>

</template>

<script>

import store from '@/store/'
import {mapState} from 'vuex'
import {OTable, OPagination, OBreadCrumb, OSelect} from '@/components/OmnihControl'
import FeatureGate from '@/components/upsell/FeatureGate.vue'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { usePointSystem } from '@/composables/pointsystem'
import { useToast } from '@/composables/useToast'

export default {
    setup() {
        const { showCorporatePointPlan } = usePointSystem()
        const { showToast } = useToast()

        let meta = computed(() => store.state.Pointplan.meta)

        let page = reactive({
            isLoading: false,
            output: false,
            component: 'point_plan'
        });

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        const write = ref(false);

        let fields = ref([
            'No',
            'Id',
            'Name',
            'Point',
            'Price',
            'Action'
        ]);

        const merchants = ref([]);
        const validation = ref('');

        const selectMerchant = ref();

        const selectedBusinessProfile = reactive({
            corporate_id: null,
            branch_id: null,
            merchant_id: null
        });

        const pointplanSearch = ref([]);

        const selectPointplan = ref();

        const searchBy = reactive({
            selected:"code",
            criteria:"",
            date_start: "",
            date_end: ""
        })

        const searchOptions = reactive([
            { value: 'name', text: 'name' }
        ])

        const thisComponentShow = ref(true);

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    loadSelectedBusinessProfile();
                }
            }
        );

        onMounted(() => {
            if (selfLoaded.value) {
                loadSelectedBusinessProfile();
            }
        });

        function copyToClipboard(text) {
            navigator.clipboard.writeText(text)
                .then(() => {                    
                    showToast({
                        type: 'success',
                        title: 'Success',
                        message: 'ID successfully copied to clipboard!'
                    });
                })
                .catch(err => {                    
                    console.error('Cannot copy ID: ', err);
                    showToast({
                        type: 'error',
                        title: 'Error',
                        message: 'Failed to copy ID'
                    });
                });
        }

        function load_state(){
            page.isLoading = true;

            store.commit('Pointplan/clear_filter');

            let filter = {};
            
            if (showCorporatePointPlan.value) {
                // Centralize mode
                filter = { corporate_id: selectedBusinessProfile.corporate_id };
                store.commit('Pointplan/add_filter', {filter});
            } else {
                // decentralize mode
                if (selectedBusinessProfile.merchant_id) {
                    filter = { merchant_id: selectedBusinessProfile.merchant_id };
                } else if (selectMerchant.value && selectMerchant.value !== 'all') {
                    filter = { merchant_id: selectMerchant.value };
                } else if (selectedBusinessProfile.branch_id) {
                    filter = { branch_id: selectedBusinessProfile.branch_id };
                }
                store.commit('Pointplan/add_filter', {filter});
            }

            store.dispatch('Pointplan/read')
            .then(() => {
                if (store.state.Auth.currUser.level === 'root') {
                    write.value = true;
                } else {
                    const userModules = store.state.Auth.userInfo.modules;

                    if (userModules) {
                        const matchingModule = userModules.find(module => module.module_name === page.component);
                        write.value = matchingModule ? matchingModule.write : false;
                    } else {
                        console.error('userModules is undefined');
                        write.value = false;
                    }
                }
            }).catch((err) => {
                validation.value = err.response.data.message;
                console.error(err);
            })
            .finally(()=>{
                page.isLoading = false;
                page.output=true;
            });
        }

        function destroy(id) {

            page.isLoading = true;
            
            setTimeout(() => {
                page.isLoading = false;
            }, 5000);

            if(confirm("Do you really want to delete ?")){
            
                store.dispatch('Pointplan/delete',id)
                .then(() => {
                    store.dispatch('Pointplan/read')
                    .then(function(){
                        })
                    .catch((err) => console.error(err));
                }).catch((err) => {
                    console.log(err);
                    validation.value = err.message;
                }).finally(() => {
                    page.isLoading = false;
                });
            }else{
                page.isLoading = false;
            }
        }

        function formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }

        function navPage(page){
            const _meta = {... meta.value, page}

            console.log({page});
            console.log({_meta});
            store.commit('Pointplan/switch_page',{meta:_meta})
            load_state()
        }

        async function loadSelectedBusinessProfile() {
            await store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                selectedBusinessProfile.corporate_id = businessProfile.corporate_id;
                selectedBusinessProfile.branch_id = businessProfile.branch_id;
                selectedBusinessProfile.merchant_id = businessProfile.merchant_id;
                selectMerchant.value = businessProfile.merchant_id == null ? "all" : businessProfile.merchant_id;

                if (!showCorporatePointPlan.value && businessProfile.merchant_id == null) {
                    loadMerchants();
                }
            }).finally(() => {
                load_state();
            });
        }

        function loadMerchants() {
            const filter = {
                branch_id: selectedBusinessProfile.branch_id,
            }

            store.commit('Merchant/add_filter', {filter});
            store.dispatch('Merchant/read').then(() => {
                merchants.value = [{value: "all", text: "From all merchant"}, ...store.state.Merchant.merchants.map((merch)=>({'value':merch.id,'text':merch.name}))]
            })
        }

        function search(searchBy){
            const {selected, criteria, date_start, date_end} = searchBy;

            if (selected) {
                let search = {}

                if (criteria && selected !== 'created_at'){
                    search[selected] = criteria;
                }else if(date_start && date_end){
                    search[selected] = `${date_start}, ${date_end}`;
                }

                store.commit('Pointplan/set_search', {search});
                store.dispatch('Pointplan/read').then(() => {});
            }

        }

        function clearSearch(){
            store.commit('Pointplan/clear_search');
            store.dispatch('Pointplan/read').then(() => {});
        }

        watch(
            () => selectMerchant.value,
            (newVal) => {
                // decentralized mode watcher
                if (showCorporatePointPlan.value) {
                    return;
                }

                const filter = newVal == "all" ? { branch_id: selectedBusinessProfile.branch_id } : { merchant_id: newVal }

                store.commit('Pointplan/add_filter', {filter});
                store.dispatch('Pointplan/read')
                .then()
                .catch((err) => {
                    validation.value = err.response.data.message;
                    thisComponentShow.value = false;
                    console.error(err);
                })
                .finally(() => page.output = true);
            }
        )

        return {
            page,
            destroy,
            fields,
            formatPrice,
            load_state,
            meta,
            navPage,
            selectedBusinessProfile,
            merchants,
            selectMerchant,
            pointplanSearch,
            selectPointplan,
            searchBy,
            searchOptions,
            search,
            clearSearch,
            copyToClipboard,
            validation,
            thisComponentShow,
            write,
            selfLoaded,
            showCorporatePointPlan
        }
    },
    computed: {
        ... mapState({
            // arrow functions can make the code very succinct!
            pointplans: state => state.Pointplan.pointplans,
        }),
    },
    components:{
        OTable,
        OPagination,
        OBreadCrumb,
        OSelect,
        FeatureGate
    }
}
</script>

<style scoped>
    .form-group {
        width: 250px;
        text-align: left;
        padding-left: 16px;
    }

    .card {
        background-color: #ffffff;
    }

    .list-table {
        margin-top: 24px;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        overflow: hidden;
    }
</style>